import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import AddInventory from './AddInventory';
import UpdateInventory from './UpdateInventory';
import { Link, useNavigate } from 'react-router-dom';
import ModalComponent from '@components/Modal/ModalComponent';
import Loading from '@components/Shared/Loader/Loading';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import NtxTable from '@components/DataTable/NtxTable';
 import { usePermissions } from '@Helper/Permisstions/usePermissions';
// import NeatixModal from '@components/Modal/NeatixModal';

const Index = () => {
  const { HasPermission } = usePermissions();
  const [Show, setShow] = useState(false);
  const [inventoryId, setInventoryId] = useState('');

  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();

  const { OrganizationInventory: data, loading, error } = useGetOrganizations();

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('location'), key: 'location' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = data?.map((item: any) => {
    let rowClass;

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      location: i18n.language === 'ar' ? item.locationName2 : item.locationName,
      action: (
        <div className='btn-group'>
          {HasPermission('INVViewInventoryDetails') && HasPermission('INVEditSubInventory') && (
            <button
              hidden={true}
              type='button'
              className='btn btn-outline-theme m-0'
              data-bs-toggle='modal'
              data-bs-target='#modalUpdateInventory'
              onClick={() => {
                setInventoryId(item.id);
              }}
            >
              <i className='far fa-lg me-2 fa-fw fa-edit'></i>
              {t('Button.Edit')}
            </button>
          )}
          {HasPermission('INVViewSubInventoryList') && (
            <button
              type='button'
              className='btn btn-outline-theme m-0'
              onClick={() => Navigate(`${item.id}/SubInventory`)}
            >
              <i className=' fa-lg me-2 bi bi-shop-window '></i>
              {t('SubInventory')}
            </button>
          )}

          {HasPermission('INVViewInventoryAssignmentItemsList') && (
            <button
              type='button'
              className='btn btn-outline-theme m-0'
              onClick={() => Navigate(`${item.id}/AssignmentItems`)}
            >
              <i className='fa-lg me-2 bi bi-box-seam'></i>
              {t('Items')}
            </button>
          )}
        </div>
      )
    };
  });

  //________________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Inventories',
              link: null
            }
          ]}
          PageName='Inventories'
        />

        <div className='ms-auto'>
          {HasPermission('INVAddInventory') && (
            <Link
              to=''
              className='btn me-1 btn-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalِAddInventory'
              onClick={() => setShow(true)}
            >
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('NewInventory')}
            </Link>
          )}
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddInventory')} id='modalِAddInventory' size='lg'>
        {Show && <AddInventory />}
      </ModalComponent>

      <ModalComponent title={t('EditInventory')} id='modalUpdateInventory' size='lg'>
        {inventoryId && <UpdateInventory inventoryId={inventoryId} />}
      </ModalComponent>

      {/* <NeatixModal show={Show2} setShow={setShow2} size='lg'>
        {inventoryId && <UpdateInventory inventoryId={inventoryId} />}
      </NeatixModal> */}
    </div>
  );
};

export default Index;
